import { ReactNode } from 'react'

type AspectRatioBoxProps = {
  width: number
  height: number
  responsive?: boolean
  children?: ReactNode
} & React.HTMLProps<HTMLDivElement>

const AspectRatioBox = ({
  width,
  height,
  responsive,
  children,
  style,
  ...rest
}: AspectRatioBoxProps) => {
  return (
    <div
      style={{
        ...style,
        position: 'relative',
        width: responsive ? '100%' : width,
        maxWidth: '100%',
        height: 0,
        paddingBottom: `${(height / width) * 100}%`
      }}
      {...rest}
    >
      {children}
    </div>
  )
}

export default AspectRatioBox
